
export const getCurrentDate = (): Date => {
    return new Date();
};
